import axios from 'axios'

export const executeAPICustomAction = async (
  dispatch,
  options,
  dependencies,
  helpers
) => {
  let { customActionId } = options

  const { getBaseAPIURL } = helpers

  let inputs = {}

  for (let itm in dependencies) {
    inputs[itm] = dependencies[itm].value
  }

  let url = `${getBaseAPIURL()}/custom-action/${customActionId}/execute`
  return await axios.post(url, inputs)
}
